module.exports = __webpack_public_path__ + "static/media/evolito-logo.0f4d8a03.png";